import decode from "jsonwebtoken/decode";
import { browserName, clearCache } from "src/shared/utils";
import { LOCALSTORAGE_TOKEN_KEY, LOCALSTORAGE_USER_META } from "../config";

interface IUserService {
  token: string | null;
  isLoggedIn: () => boolean;
  logout: () => Promise<void>;
}

const CRYPTO_ALGORITHM = "HS512";

type RawUserInfo = {
  first_name?: string;
  last_name?: string;
  user?: string;
};

type UserInfo = {
  initials: string;
  name: string;
  username: string;
};

class UserService implements IUserService {
  private _token: string | null = null;
  public userInfo: UserInfo | null = null;
  public meta = "";
  public set token(apiToken: string | null) {
    this._token = apiToken;
    if (apiToken) {
      localStorage.setItem(LOCALSTORAGE_TOKEN_KEY, apiToken as string);
      const userinfo: RawUserInfo = this.decodeToken(apiToken);
      console.log("userinfo :>> ", userinfo);
      const username = userinfo && userinfo.user ? userinfo.user : "unknown";
      const appVersion = process.env.ANOBIS_UI_APP_VERSION || "unknown";
      const meta = `v=${appVersion}; b=${browserName}; un=${username};`;
      this.meta = meta;
      localStorage.setItem(LOCALSTORAGE_USER_META, meta);
      this.setUserInfo(userinfo);
    }
  }

  public get token() {
    return localStorage.getItem(LOCALSTORAGE_TOKEN_KEY) ? localStorage.getItem(LOCALSTORAGE_TOKEN_KEY) : this._token;
  }

  public isLoggedIn() {
    return !!this.token;
  }

  public setTokenFromStorage() {
    this.token = this.token;
  }

  private decodeToken(token) {
    return decode(token, {
      algorithm: CRYPTO_ALGORITHM,
    });
  }

  private setUserInfo({ first_name = "", last_name = "", user }: RawUserInfo) {
    /**Decoded token has first Name and last name */
    if (first_name && last_name) {
      const firstInitial = first_name.charAt(0);
      const secondInitial = last_name.charAt(0);
      this.userInfo = {
        initials: firstInitial + secondInitial,
        name: first_name + " " + last_name,
        username: user || first_name + "." + last_name,
      };
    } else {
      /**Fall back for already loggedin users */
      const matchResult = user && user.match(/^(\w)\w+(\.?\w)/);
      if (!matchResult) return;
      const [, firstInitial, secondInitial = ""] = matchResult;
      this.userInfo = {
        initials: firstInitial + secondInitial.replace(/\./, ""),
        name: user ? user.split(".").join(" ") : "",
        username: user || "",
      };
    }
  }

  public async logout() {
    this.token = null;
    this.userInfo = null;
    this.meta = "";
    localStorage.removeItem(LOCALSTORAGE_TOKEN_KEY);
    localStorage.removeItem(LOCALSTORAGE_USER_META);
    await clearCache();
  }
}

export default new UserService();
